import React from 'react';
import {IconButton, Menu, MenuItem} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {useTranslation} from 'react-i18next';
import {RoleMembersDialog} from './RoleMembersDialog';
import {useModal} from 'common/hooks/useModal';
import {useOpenSubDialog} from 'features/layout/redux/hooks/useOpenSubDialog';
import {DialogTypes} from 'common/names';
import {IAdminRole} from 'types/diplomat/settings/adminroles/AdminRole';
import {IDiplomatAdminUserGroup} from 'types/diplomat/settings/adminroles/DiplomatAdminUserGroup';
import {useCreateAdminRole} from 'redux/settings/hooks/useCreateAdminRole';
import {useUpdateAdminRole} from 'redux/settings/hooks/useUpdateAdminRole';
import {IRoleMembersSchema} from './RoleMembersForm';

const ITEM_HEIGHT = 48;

const RolesMenu = ({
   role,
   prefix,
   refetch,
   onDelete,
}: {
   role: IAdminRole;
   prefix: `roles.${number}`; // Path<IRoles>
   refetch: () => void;
   onDelete: (items: IAdminRole[]) => void;
}) => {
   const {t} = useTranslation();
   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
   const open = Boolean(anchorEl);
   const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
   };
   const handleClose = () => {
      setAnchorEl(null);
   };
   const {
      open: roleMemenrsOpen,
      handleOpen: openRoleMembers,
      handleClose: closeRoleMemebers,
   } = useModal();

   const onCloseMemebers = React.useCallback(
      (updated?: boolean) => {
         closeRoleMemebers();
         if (updated) {
            refetch();
         }
      },
      [closeRoleMemebers]
   );

   // const setField = useSetFieldValueCb<IAdminRoles>();

   const updateAdminRole = useUpdateAdminRole();
   const openRename = useOpenSubDialog(DialogTypes.InputDialog.id, {
      title: 'Rename Role',
      label: 'Rename',
      value: role.name,
      onClose: (res: any) => {
         console.debug('Rename', res);
         handleClose();
         if (res?.name) {
            const updatedRole = {...role, name: res.name};
            updateAdminRole({roles: [updatedRole]});
            // setField(`${prefix}.${RoleNames.name}`, res.name);
         }
      },
   });
   const openCreate = useCreateAdminRole(role);
   const openDelete = () => {
      onDelete([role]);
   };

   return (
      <div>
         <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
         >
            <MoreVertIcon />
         </IconButton>
         <Menu
            id="long-menu"
            MenuListProps={{
               'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
               style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '20ch',
               },
            }}
         >
            <MenuItem
               onClick={() => {
                  openRoleMembers();
                  handleClose();
               }}
            >
               {t('Members...')}
            </MenuItem>
            <MenuItem onClick={openRename}>{t('Rename...')}</MenuItem>
            <MenuItem onClick={openCreate}>{t('Clone...')}</MenuItem>
            <MenuItem onClick={openDelete}>{t('Delete...')}</MenuItem>
         </Menu>
         {roleMemenrsOpen && <RoleMembersDialog role={role} onClose={onCloseMemebers} />}
      </div>
   );
};

export default RolesMenu;
